import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDashboardEvents, Event } from "@/services/eventService";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";

export function EventBanner() {
    const [events, setEvents] = useState<Event[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadEvents();
    }, []);

    const loadEvents = async () => {
        try {
            const dashboardEvents = await getDashboardEvents();
            setEvents(dashboardEvents);
        } catch (error) {
            console.error("Error loading dashboard events:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading || events.length === 0) {
        return null;
    }

    return (
        <div className="space-y-4 mb-6">
            {events.map((event) => (
                <Link key={event.id} to={`/${event.page_slug}`}>
                    <Card className="overflow-hidden hover:shadow-lg transition-shadow cursor-pointer rounded-custom-paddings p-0">
                        {event.banner_image_url && (
                            <div className="relative">
                                <img
                                    src={event.banner_image_url}
                                    alt="Event banner"
                                    className="w-full h-48 object-cover"
                                />
                                {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                                    <div className="flex items-center gap-2 text-white">
                                        <Calendar className="w-4 h-4" />
                                        <span className="text-sm">
                                            {new Date(event.start_date).toLocaleDateString('en-US')} - {new Date(event.end_date).toLocaleDateString('en-US')}
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        )}
                        {!event.banner_image_url && event.wysiwyg_content && (
                            <div className="p-6">
                                <div
                                    className="prose max-w-none line-clamp-3"
                                    dangerouslySetInnerHTML={{ __html: event.wysiwyg_content }}
                                />
                            </div>
                        )}
                    </Card>
                </Link>
            ))}
        </div>
    );
}
